import { EXTERNAL_GROUP_NAME } from '../../../Utils';

const getGroupNameByType = (type, i18n) => {
    if (type === EXTERNAL_GROUP_NAME) {
        return i18n.t('attachments_preview.collaboration.groups.external_collaborators_group');
    }

    return i18n.t('attachments_preview.collaboration.groups.buyer_seller_group');
};

export default getGroupNameByType;
